import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title, Meta } from '@angular/platform-browser';
import { ViewportScroller } from '@angular/common';

import Swal from 'sweetalert2'
import { isNull } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'app-tracker',
    templateUrl: './tracker.component.html',
    styleUrls: ['./tracker.component.css']
})
export class TrackerComponent implements OnInit {

    trackerList: any;
    trackerListRecon: any = {};
    trackCode: any = "";
    trackerDisplay: boolean = false;
    visible: boolean = false;
    imageTracker: string = "./assets/image/step-1.png";
    trackerArr: any;
    elementId: string = "";
    waybill: string = '';
    key: string = '';
    podLinks: { [waybill: string]: string } = {};
    podErrors: { [waybill: string]: string } = {};

    constructor(
        private spinner: NgxSpinnerService,
        private route: Router,
        private apiService: ApiService,
        private titleService: Title,
        private metaService: Meta,
        private viewportScroller: ViewportScroller
    ) { }

    ngOnInit(): void {
        this.spinner.show();

        this.titleService.setTitle("Track & Trace Your Item | Express Delivery Service | Line Clear Express")

        const metaDesc = this.metaService.getTag('name=description');

        if (!metaDesc) {
            this.metaService.addTags([
                { name: "description", content: "Track & Trace Parcel with Line Clear Express Malaysia. Easy & Timely Delivery" }
            ]);
        } else {
            this.metaService.updateTag(
                { name: "description", content: "Track & Trace Parcel with Line Clear Express Malaysia. Easy & Timely Delivery" },
                "name=description"
            )
        }

        //console.log('URL 2: '+ location.href);
        if (location.href.includes('id=')) {
            this.elementId = location.href.substring(location.href.indexOf("=") + 1);
            this.elementId = this.elementId.split('_').join(',')
            this.trackCode = this.elementId
            document.getElementById("track").click();
            this.trackCode = ""

        }
        else {
            //do nothing
        }

    }

    showSpinner() {
        this.visible = true;

        setTimeout(() => {
            ;
            this.hideSpinner()
        }, 1500);
    }

    hideSpinner() {
        this.visible = false;
    }


    getTrackerData(elementId: any): void {
        this.podLinks = {};
        this.podErrors = {};
        this.visible = true;
        const trackerStr = this.trackCode

        var str_array = trackerStr.split(',');

        const dataArr = []

        for (var i = 0; i < str_array.length; i++) {
            // Trim the excess whitespace.
            str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
            dataArr.push(str_array[i])
        }


        let data = {
            "SearchType": "WayBillNumber",
            "WayBillNumber": dataArr
        }

        this.apiService.postTracker(data).subscribe((res: any) => {

            console.log("Tracker Response:", res);

            var error_message_awb = "The waybill number(s) entered is invalid or does not exist in the system"
            var error_message_ship_ref = "Minimum 1 ShipmentRef required"
            var error_message = "is invalid or does not exist in the system"

            if (res.message !== error_message_awb) {
                this.trackerDisplay = true

                this.trackerArr = res
                this.trackerList = res

                let trackerData = []
                let trackerlocation = []
                let Trackerlocation1 = []

                this.trackerList.forEach((tracker, trackerIdx) => {
                    tracker.forEach((element, index) => {
                        switch (element.StatusCode) {
                            case 'WB004':
                                var des = element.Description;
                                des = des.replace("Manifest Out Scan completed at Pickup branch at", "Checked Out and Departed to Branch from");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB009':
                                var des = element.Description;
                                des = des.replace("Manifest Out Scan completed at Pickup Hub at", "Checked Out and Departed to Hub from");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB013':
                                var des = element.Description;
                                des = des.replace("Manifest Out Scan completed", "Transit Cage Out");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB017':
                                var des = element.Description;
                                des = des.replace("Ready for Delivery", "Parcel has Arrived");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB030':
                                var des = element.Description;
                                des = des.replace("Manifest Out from Station at", "Checked Out and Departed to Station from");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB031':
                                var des = element.Description;
                                des = des.replace("Manifest Out from Platform/Hotspot at", "Checked Out and Departed to Platform/Hotspot from");
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB005': case 'WB007': case 'WB010': case 'WB014':
                            case 'WB016': case 'WB019': case 'WB022': case 'WB023':
                            case 'WB025': case 'WB026': case 'WB056':
                                this.trackerList[trackerIdx][index] = {}; // remove all description
                                break;
                            case 'WB021': //delivered
                                var des = element.Description;
                                element.Description = des.split(" by ")[0];

                                trackerlocation.push(element.TransitLocation);
                                break;
                            case 'WB020': //undelivered
                                var des = element.Description;
                                element.Description = des.split(" by ")[0] +
                                    " Reason: " + element.UndelReason.charAt(0).toUpperCase() + element.UndelReason.slice(1).toLowerCase();
                                trackerlocation.push(element.TransitLocation);
                                break;
                            default:
                                var des = element.Description;
                                element.Description = des.split(" by ")[0];
                                trackerlocation.push(element.TransitLocation);
                                break;
                        }


                        //drs block
                        //console.log('element.StatusCode', element.StatusCode);
                        if (element.StatusCode == "WB055") {
                            //console.log('element.UndelCode', element.UndelCode);
                            switch (element.UndelCode) {
                                case 'DD012V001': case 'DD012V002':
                                    this.trackerList[trackerIdx][index] = {};
                                    break;
                                case 'DD012V003':
                                    var des = element.Description;
                                    //console.log('des', des);
                                    element.Description = des.split(" by ")[0] +
                                        " Reason: " + element.UndelReason.charAt(0).toUpperCase() + element.UndelReason.slice(1).toLowerCase();
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                default:
                                    break;

                            }
                        }
                    });
                });

                this.apiService.getbranchplace(trackerlocation).subscribe((res: any[]) => {
                    Trackerlocation1 = res;
                    let i = 0;

                    this.trackerList.forEach(trackerID => {
                        trackerID.forEach(element => {
                            if (typeof element.TransitLocation === 'string') {
                                element.Description = element.Description.replace(element.TransitLocation, Trackerlocation1[i]);
                                i++;
                            }
                        });
                    });

                });

                this.trackerList.forEach(trackerID => {
                    let trackingstatus = trackerID[0]
                    // check 1st object since it is the latest status 

                    if (trackerID[0].message != undefined && trackerID[0].message.includes(error_message)) {
                        //not push when message return "is invalid or does not exist in the system"
                        //do nothing
                    }
                    else {
                        switch (trackingstatus.Status) {
                            case "Delivered":
                                this.imageTracker = "./assets/image/step-5.png"
                                break;
                            case "Out for Delivery":
                                this.imageTracker = "./assets/image/step-4.png"
                                break;
                            case "Awaiting Shipment Handover":
                                this.imageTracker = "./assets/image/step-1.png"
                                break;
                            default:
                                // all other status will be in transit status 
                                this.imageTracker = "./assets/image/step-3.png"
                                break;
                        }

                        trackerData.push({ "data": trackerID, "image": this.imageTracker })
                    }
                });


                this.trackerListRecon = trackerData
                //console.log('json data: ', this.trackerListRecon)

                // Filter out empty objects in each trackerListRecon entry
                this.trackerListRecon.forEach((item, idx) => {
                    //console.log("item", item);
                    if (item && Array.isArray(item.data)) {
                        this.trackerListRecon[idx].data = item.data.filter(value => Object.keys(value).length !== 0);
                    }

                });
                //console.log('json data2 : ', this.trackerListRecon)
                this.trackCode = ""
                window.history.replaceState(null, document.title, "/tracker");
                this.resetPod(this.waybill);
            }
            else {
                this.trackerDisplay = false

                // looking for ShipmentRef
                let data2 = {
                    "SearchType": "ShipmentRef",
                    "ShipmentRef": dataArr
                }

                this.apiService.postTracker(data2).subscribe((res: any) => {
                    // console.log('raw resp:', res)

                    this.trackerDisplay = true
                    this.trackerList = res

                    let trackerData = []
                    let trackerlocation = []
                    let Trackerlocation1 = []

                    if (this.trackerList.message != undefined) {
                        if (this.trackerList.message == error_message_ship_ref) {
                            Swal.fire("Not Found!", "Error : <small style='color: red; font-style: italic;'>Item Not Found!</small>", "error")
                            this.trackerDisplay = false;
                            this.trackCode = "";
                            return false;
                        }
                        else if (this.trackerList.message.includes(error_message)) {
                            Swal.fire("Not Found!", "Error : <small style='color: red; font-style: italic;'>Item Not Found!</small>", "error")
                            this.trackerDisplay = false;
                            this.trackCode = "";
                            return false;
                        }
                    }


                    this.trackerList.forEach((tracker, trackerIdx) => {
                        tracker.forEach((element, index) => {
                            // console.log('element', element)
                            switch (element.StatusCode) {
                                case 'WB004':
                                    var des = element.Description;
                                    des = des.replace("Manifest Out Scan completed at Pickup branch at", "Checked Out and Departed to Branch from");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB009':
                                    var des = element.Description;
                                    des = des.replace("Manifest Out Scan completed at Pickup Hub at", "Checked Out and Departed to Hub from");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB013':
                                    var des = element.Description;
                                    des = des.replace("Manifest Out Scan completed", "Transit Cage Out");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB017':
                                    var des = element.Description;
                                    des = des.replace("Ready for Delivery", "Parcel has Arrived");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB030':
                                    var des = element.Description;
                                    des = des.replace("Manifest Out from Station at", "Checked Out and Departed to Station from");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB031':
                                    var des = element.Description;
                                    des = des.replace("Manifest Out from Platform/Hotspot at", "Checked Out and Departed to Platform/Hotspot from");
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB005': case 'WB007': case 'WB010': case 'WB014':
                                case 'WB016': case 'WB019': case 'WB022': case 'WB023':
                                case 'WB025': case 'WB026': case 'WB056':
                                    this.trackerList[trackerIdx][index] = {}; // remove all description
                                    break;
                                case 'WB021': //delivered
                                    var des = element.Description;
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                case 'WB020': //undelivered
                                    var des = element.Description;
                                    element.Description = des.split(" by ")[0] +
                                        " Reason: " + element.UndelReason.charAt(0).toUpperCase() + element.UndelReason.slice(1).toLowerCase();
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                                default:
                                    var des = element.Description;
                                    element.Description = des.split(" by ")[0];
                                    trackerlocation.push(element.TransitLocation);
                                    break;
                            }

                            //drs block
                            //console.log('element.StatusCode', element.StatusCode);
                            if (element.StatusCode == "WB055") {
                                //console.log('element.UndelCode', element.UndelCode);
                                switch (element.UndelCode) {
                                    case 'DD012V001': case 'DD012V002':
                                        this.trackerList[trackerIdx][index] = {};
                                        break;
                                    case 'DD012V003':
                                        var des = element.Description;
                                        //console.log('des', des);
                                        element.Description = des.split(" by ")[0] +
                                            " Reason: " + element.UndelReason.charAt(0).toUpperCase() + element.UndelReason.slice(1).toLowerCase();
                                        trackerlocation.push(element.TransitLocation);
                                        break;
                                    default:
                                        break;

                                }
                            }
                        });
                    });

                    this.apiService.getbranchplace(trackerlocation).subscribe((res: any[]) => {
                        Trackerlocation1 = res;
                        //console.log('Trackerlocation1', Trackerlocation1)
                        let i = 0;
                        this.trackerList.forEach(trackerID => {
                            trackerID.forEach(element => {
                                if (typeof element.TransitLocation === 'string') {
                                    element.Description = element.Description.replace(element.TransitLocation, Trackerlocation1[i]);
                                    i++;
                                    //console.log('element.TransitLocation', element.Description)
                                }
                            });
                        });
                    });

                    this.trackerList.forEach(trackerID => {
                        let trackingstatus = trackerID[0]

                        if (trackerID[0].message != undefined && trackerID[0].message.includes(error_message)) {
                            //not push when message return "is invalid or does not exist in the system"
                            //do nothing
                        }
                        else {
                            switch (trackingstatus.Status) {
                                case "Delivered":
                                    this.imageTracker = "./assets/image/step-5.png"
                                    break;
                                case "Out for Delivery":
                                    this.imageTracker = "./assets/image/step-4.png"
                                    break;
                                case "Awaiting Shipment Handover":
                                    this.imageTracker = "./assets/image/step-1.png"
                                    break;
                                default:
                                    this.imageTracker = "./assets/image/step-3.png"
                                    break;
                            }

                            trackerData.push({ "data": trackerID, "image": this.imageTracker })
                        }
                    });


                    this.trackerListRecon = trackerData
                    //console.log('json data: ', this.trackerListRecon)

                    // Filter out empty objects in each trackerListRecon entry
                    this.trackerListRecon.forEach((item, idx) => {
                        if (item && Array.isArray(item.data)) {
                            this.trackerListRecon[idx].data = item.data.filter(value => Object.keys(value).length !== 0);
                        }
                    });
                    //console.log('json data2 : ', this.trackerListRecon)

                    this.trackCode = ""
                    window.history.replaceState(null, document.title, "/tracker");
                    this.resetPod(this.waybill);
                })
            }
        }, error => {
            Swal.fire("Not Found!", "Error : <small style='color: red; font-style: italic;'>Item Not Found!</small>", "error")
            this.trackerDisplay = false
        })


        setTimeout(() => {
            ;
            this.visible = false
            this.viewportScroller.scrollToAnchor(elementId);
        }, 1500);

    }


    getPOD(waybill: string, key: string, item?: any) {

        if (!key || key.trim() === "") {
            this.podErrors[waybill] = "Please enter last 4 digits of contact number";
            this.podLinks[waybill] = "";
            return;
        }

        if (key.trim().length !== 4 || isNaN(Number(key))) {
            this.podErrors[waybill] = "Please enter last 4 digits of contact number";
            this.podLinks[waybill] = "";
            return;
        }

        this.apiService.getPodFileInfo(waybill, key).subscribe({
            next: (res1: any) => {
                this.podErrors[waybill] = "";  // Clear old error
                this.podLinks[waybill] = "";

                const pod1 = res1[0];
                const pod2 = res1[1];
                //console.log("res1", res1);
                if (res1.length > 1) {
                    this.podLinks[waybill] =
                        `Download POD: <a href="${pod1}" target="_blank">click here</a><br/>` +
                        `Download POD: <a href="${pod2}" target="_blank">click here</a>`;
                } else if (res1.length === 1) {
                    this.podLinks[waybill] =
                        `Download POD: <a href="${pod1}" target="_blank">click here</a>`;
                } else {
                    this.podLinks[waybill] = "No POD found";
                    if (item) item.podCode = "";
                }
            },
            error: (err) => {
                if (err.status === 403) {
                    this.podErrors[waybill] = "Invalid contact number";
                }
                else if (err.status === 400) {
                    this.podErrors[waybill] = "Invalid contact number";
                }
                else {
                    this.podErrors[waybill] = "Verification failed. Please try again.";
                }
            }
        });
    }

    resetPod(waybill: string) {
        this.podLinks[waybill] = '';
        this.podErrors[waybill] = '';
    }


}
